module.exports = __webpack_public_path__ + "static/Icons_Refinance_large-49e610c5bdc2aab33751918c3c7297fb.png";